import { Suspense, useEffect } from "react";
import Loader from "../components/LoaderComponent";
import LastMinuteDeals from "../components/HotelCard/LastMInuteDeals";
import { useQuery } from "react-query";
import { fetchHotels } from "../api-client"; // Ensure you have this import
import { HelmetProvider, Helmet } from "react-helmet-async";

const LastMinuteDealsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    const { data: lastMinuteHotels, isLoading, error } = useQuery('hotels', fetchHotels);

    if (isLoading) return <Loader />;
    if (error) return <div>Error loading hotels</div>;

    return (
        <>
        <HelmetProvider>
            <Helmet>
            <title>Last Minute Holidays & Deals | Halo Holidays</title>
            <meta name="description" content="Escape the ordinary with Halo Holidays' last minute deals. Discover incredible savings on beach holidays, city breaks, and all-inclusive resorts." />
            {/* <meta name="keywords" content="travel, hotels, holidays, deals, holiday packages" /> */}
            </Helmet>
        </HelmetProvider>
            <section className="px-4 md:px-0 mb-4 mt-8">
                <h1 className="text-3xl font-bold">Unbelievable Last-Minute Offers Just for You!</h1>
                <p>Ready to escape? Your dream getaway is closer than you think.</p>
            </section>
        
            {/* Desktop view */}
            <section>
                <Suspense fallback={<Loader />}>
                    <LastMinuteDeals hotels={lastMinuteHotels || []} />
                </Suspense>
            </section>

            {/* Mobile view */}
            {/* <section data-section="lastMinute" className="container block md:hidden lg:hidden mb-10">
                <Suspense fallback={<Loader />}>
                    <LastMinuteDealsSlider hotels={lastMinuteHotels || []} />
                </Suspense>
            </section> */}
        </>
    );
};

export default LastMinuteDealsPage;